// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Roboto", sans-serif;
  box-sizing: border-box;
}
/* * p {
  color: #4d4d4d;
} */
.App {
  background-color: #E4FFFF;
  /* margin-bottom: 5%; */
}

body {
  background-color: #E4FFFF;
}

.wrapper {
  display: flex;
}
h1 {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  font-size: 3rem;
  color: #4d4d4d;
  text-align: center;
}

h2 {
  font-family: "Roboto", sans-serif;
  color: #4d4d4d;
  font-size: 1.5rem;
  text-align: center;
}
.average {
  display: block;
  align-content: center;
  margin-left: 25%;
  /* flex-direction: column;
    margin: auto; */
}
.row{
    margin-top: 4%;
}
.iconButton{
 height: 4vh;
 left: 38%;
}

@media only screen and (min-width: 300px) and (max-width: 749px) {
  .dashContent {
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 1.5rem;
  }
  footer p {
    font-size: 0.8rem;
  }
  .topBar {
    flex-wrap: wrap;
    align-content: center;
  }
  .topBar .apexcharts-canvas{
      margin-left: 13%;
  }
  .mobileWrap {
    display: flex;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
  }
  .dashRow {
    display: flex;
    flex-direction: column;
  }
  .marginLeft {
    margin-right: -20%;
  }
  .Brandcard {
    width: 100%;
    margin-top: 3%;
    margin-bottom: 2%;
    margin-left: -10%;
  }
  .average {
    margin-left: 10%;
  }
  .navBar img {
    width: 60%;
    height: auto;
  }
  .dashRow {
    margin-left: 0;
  }
  .topBar .card {
    width: 80%;
  }
  .staffNav img {
    width: 60%;
  }
  .row {
    margin-left: -10%;
  }
}
@media only screen and (min-width: 750px) and (max-width: 1200px) {
  .cards {
    margin-left: -20%;
  }
  .topBar {
    flex-wrap: wrap;
  }
  .Brandcard {
    width: 100%;
    margin-top: 3%;
    margin-bottom: 2%;
  }
  .average {
    margin-left: 10%;
  }
  .dashRow {
    display: flex;
    flex-direction: column;
  }
  .marginLeft {
    margin-right: -20%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;;GAEG;AACH;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB;mBACiB;AACnB;AACA;IACI,cAAc;AAClB;AACA;CACC,WAAW;CACX,SAAS;AACV;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;MACI,gBAAgB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["* {\n  font-family: \"Roboto\", sans-serif;\n  box-sizing: border-box;\n}\n/* * p {\n  color: #4d4d4d;\n} */\n.App {\n  background-color: #E4FFFF;\n  /* margin-bottom: 5%; */\n}\n\nbody {\n  background-color: #E4FFFF;\n}\n\n.wrapper {\n  display: flex;\n}\nh1 {\n  font-family: \"Roboto\", sans-serif;\n  text-transform: uppercase;\n  font-size: 3rem;\n  color: #4d4d4d;\n  text-align: center;\n}\n\nh2 {\n  font-family: \"Roboto\", sans-serif;\n  color: #4d4d4d;\n  font-size: 1.5rem;\n  text-align: center;\n}\n.average {\n  display: block;\n  align-content: center;\n  margin-left: 25%;\n  /* flex-direction: column;\n    margin: auto; */\n}\n.row{\n    margin-top: 4%;\n}\n.iconButton{\n height: 4vh;\n left: 38%;\n}\n\n@media only screen and (min-width: 300px) and (max-width: 749px) {\n  .dashContent {\n    display: flex;\n    flex-direction: column;\n  }\n  h1 {\n    font-size: 1.5rem;\n  }\n  footer p {\n    font-size: 0.8rem;\n  }\n  .topBar {\n    flex-wrap: wrap;\n    align-content: center;\n  }\n  .topBar .apexcharts-canvas{\n      margin-left: 13%;\n  }\n  .mobileWrap {\n    display: flex;\n  }\n  .wrapper {\n    display: flex;\n    flex-direction: column;\n  }\n  .dashRow {\n    display: flex;\n    flex-direction: column;\n  }\n  .marginLeft {\n    margin-right: -20%;\n  }\n  .Brandcard {\n    width: 100%;\n    margin-top: 3%;\n    margin-bottom: 2%;\n    margin-left: -10%;\n  }\n  .average {\n    margin-left: 10%;\n  }\n  .navBar img {\n    width: 60%;\n    height: auto;\n  }\n  .dashRow {\n    margin-left: 0;\n  }\n  .topBar .card {\n    width: 80%;\n  }\n  .staffNav img {\n    width: 60%;\n  }\n  .row {\n    margin-left: -10%;\n  }\n}\n@media only screen and (min-width: 750px) and (max-width: 1200px) {\n  .cards {\n    margin-left: -20%;\n  }\n  .topBar {\n    flex-wrap: wrap;\n  }\n  .Brandcard {\n    width: 100%;\n    margin-top: 3%;\n    margin-bottom: 2%;\n  }\n  .average {\n    margin-left: 10%;\n  }\n  .dashRow {\n    display: flex;\n    flex-direction: column;\n  }\n  .marginLeft {\n    margin-right: -20%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
